exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".product-content-title---2FM6y{line-height:.95;font-size:10px!important}", ""]);

// exports
exports.locals = {
	"product-content-title": "product-content-title---2FM6y"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1&modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/sass-resources-loader/lib/loader.js!./src/app/directives/product/simple/style.scss
// module id = 363
// module chunks = 0